import React, { useState, useEffect } from 'react';
import { Container, Button } from 'reactstrap';

const SSP_STUDIO_URL = process.env.REACT_APP_SSP_STUDIO_URL || 'https://ssp.govcom.ai';

const SSPStudioNew = () => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  // Handle ESC key to exit fullscreen
  useEffect(() => {
    const handleEscKey = (e) => {
      if (e.key === 'Escape' && isFullscreen) {
        setIsFullscreen(false);
      }
    };

    document.addEventListener('keydown', handleEscKey);
    return () => document.removeEventListener('keydown', handleEscKey);
  }, [isFullscreen]);

  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
  };

  return (
    <>
      {isFullscreen && (
        // Fullscreen overlay that covers everything
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 10000,
          backgroundColor: '#fff'
        }}>
          {/* Exit Button */}
          <Button
            color="danger"
            size="sm"
            onClick={toggleFullscreen}
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              zIndex: 10001,
              boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
            }}
          >
            <i className="mdi mdi-close me-1"></i>
            Exit Fullscreen (ESC)
          </Button>

          {/* Fullscreen Iframe */}
          <iframe
            src={SSP_STUDIO_URL}
            title="SSP Studio New Fullscreen"
            style={{
              width: '100%',
              height: '100vh',
              border: 'none',
              display: 'block'
            }}
            allow="clipboard-read; clipboard-write"
          />
        </div>
      )}

      {/* Normal view */}
      {!isFullscreen && (
        <div className="page-content">
          <Container fluid style={{ padding: 0, height: 'calc(100vh - 70px)', position: 'relative' }}>
            {/* Fullscreen Toggle Button */}
            <Button
              color="primary"
              size="sm"
              onClick={toggleFullscreen}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                zIndex: 100,
                boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
              }}
            >
              <i className="mdi mdi-arrow-expand-all me-1"></i>
              Fullscreen
            </Button>

            {/* Normal Iframe */}
            <iframe
              src={SSP_STUDIO_URL}
              title="SSP Studio New"
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
                display: 'block'
              }}
              allow="clipboard-read; clipboard-write"
            />
          </Container>
        </div>
      )}
    </>
  );
};

export default SSPStudioNew;
